import { InsuranceInfo, insuranceInfoOptions } from '@hb/shared'
import { ActionButton, useFormWizard } from '@hb/shared-frontend'

import { EditIcon } from '@chakra-ui/icons'
import { Collapse, Flex, IconButton, Text } from '@chakra-ui/react'
import { InsuranceInfoOption } from '@hb/shared'
import { useCallback } from 'react'
import { useInsuranceInfoStage } from './context'
import { CoverageWillChange } from './CoverageWillChange'
import { MultipleCoverageOptions } from './MultipleCoverageOptions'
import { NoCoverage } from './NoCoverage'

const getButtonText = (option: InsuranceInfoOption) =>
  // if (option === 'one-plan') return 'Non-Medicaid Plan'
  // if (option === 'medicaid') return 'Medicaid Plan'
  insuranceInfoOptions.find(o => o.id === option)?.text ?? ''

const CoverageOptionSelectButton = ({
  option,
  onSelect,
}: {
  option: InsuranceInfoOption
  onSelect?: (option: InsuranceInfoOption) => void
}) => {
  const text = getButtonText(option)
  const onClick = onSelect ? () => onSelect(option) : undefined
  // return option === 'one-plan' || option === 'medicaid' ? (
  //   <SolidActionButton pointerEvents={onClick ? 'auto' : 'none'} width="100%" onClick={onClick}>
  //     {text}
  //   </SolidActionButton>
  // ) : (
  return (
    <ActionButton
      pointerEvents={onClick ? 'auto' : 'none'}
      width="100%"
      height="auto"
      _hover={{ bg: 'green.50' }}
      py={2}
      lineHeight={1.4}
      onClick={onClick}
      whiteSpace="pre-wrap"
      colorScheme="gray">
      {text}
    </ActionButton>
  )
}

const SelectedCoverageOptionView = ({
  option,
  onSelect,
}: {
  option: InsuranceInfoOption | null | undefined
  onSelect: (option: InsuranceInfoOption | undefined) => void
}) => {
  const { readOnly } = useFormWizard()
  return (
    <Collapse style={{ width: '100%' }} in={!!option}>
      <Flex gap={1.5} align="center" width="100%">
        <Flex flex={1} minW={0}>
          <CoverageOptionSelectButton option={option || 'one-plan'} />
        </Flex>
        {!readOnly ? (
          <IconButton
            borderRadius="full"
            onClick={() => onSelect(undefined)}
            icon={<EditIcon />}
            aria-label="Edit"
          />
        ) : null}
      </Flex>
    </Collapse>
  )
}
export const CoverageOptionSelect = () => {
  const { insuranceInfoData, onUpdate } = useInsuranceInfoStage()
  const { option, primaryCoverage } = insuranceInfoData ?? {}

  const onSelectOption = useCallback(
    (option: InsuranceInfoOption | undefined) => {
      const newData: Partial<InsuranceInfo> = { option }
      const existingIsMedicaid = primaryCoverage?.isMedicaid
      if (option === 'one-plan')
        newData.primaryCoverage =
          existingIsMedicaid === false ? (primaryCoverage ?? {}) : { isMedicaid: false }
      if (option === 'medicaid')
        newData.primaryCoverage =
          existingIsMedicaid === true ? (primaryCoverage ?? {}) : { isMedicaid: true }
      onUpdate(newData, false)
    },
    [onUpdate, primaryCoverage],
  )

  return (
    <Flex flexFlow="column" width="100%">
      <Text mb={1} fontSize="xl">
        Which of these best describes your coverage?
      </Text>
      <Collapse style={{ width: '100%' }} in={!option}>
        <Flex gap={1.5} flexFlow="column" flex={1} minW={0}>
          {/* <Flex gap={1.5} w="100%" align="center">
            <SolidActionButton onClick={() => onSelectOption('one-plan')} flex={1}>
              Non-Medicaid Plan
            </SolidActionButton>
            <SolidActionButton onClick={() => onSelectOption('medicaid')} flex={1}>
              Medicaid Plan
            </SolidActionButton>
          </Flex> */}
          <CoverageOptionSelectButton option="one-plan" onSelect={onSelectOption} />
          <CoverageOptionSelectButton option="medicaid" onSelect={onSelectOption} />
          <CoverageOptionSelectButton option="two-plans" onSelect={onSelectOption} />
          <CoverageOptionSelectButton option="multiple-options" onSelect={onSelectOption} />
          <CoverageOptionSelectButton option="coverage-will-change" onSelect={onSelectOption} />
          <CoverageOptionSelectButton option="no-coverage" onSelect={onSelectOption} />
          <CoverageOptionSelectButton option="not-pregnant" onSelect={onSelectOption} />
        </Flex>
      </Collapse>
      <SelectedCoverageOptionView option={option} onSelect={onSelectOption} />
      <CoverageWillChange />
      <MultipleCoverageOptions />
      <NoCoverage />
    </Flex>
  )
}
